import moment from 'moment';
import ui from '@sh/helpers/ui';
import symbols from '@sh/helpers/symbols';

export default function () {
  return {
    showModal: false,
    ui,
    symbols,
    selectedCampaigns: [],
    filter: {},
    moment,
    ready: {
      filter: false,
      campaigns: false,
      hasData: true,
      pagination: false,
    },
    table: {
      fields: [],
      items: [],
      statsTotals: {},
      advertisers: [],
      totals: {},
    },
    tableModel: {
      selectedRows: [],
      displayColumns: [],
      columnsOrder: [],
    },
    advertisersModel: 'all',
    limit: 100,
    page: 1,
    pages: 1,
    defaultRows: 100,
    search: '',
    sortField: 'cost',
    sortType: 'desc',
    columnFilter: {},
    updateCampaign: {},
    fieldName: '',
    typeOptions: [],
    editableFields: {},
    supportedTypes: [],
    bulkActionOptions: [
      { value: 'manage', content: '<span class="outline-fa-icon dark"><i class="fa fa-eye"></i></span>&nbsp; Manage' },
      { value: 'unmanage', content: '<span class="outline-fa-icon dark"><i class="fa fa-eye-slash"></i></span>&nbsp; Un-manage' },
      { value: 'archive', content: '<span class="outline-fa-icon dark"><i class="fa fa-lock"></i></span>&nbsp; Archive' },
      { value: 'unarchive', content: '<span class="outline-fa-icon dark"><i class="fa fa-unlock"></i></span>&nbsp; Un-Archive' },
    ],
    campaigns: [],
    statusFilter: [],
    statusOptions: [
      { value: { status: 'running' }, content: 'RUNNING', group: 'status' },
      { value: { status: 'paused' }, content: 'PAUSED', group: 'status' },
      { value: { status: 'out of funds' }, content: 'OUT OF FUNDS', group: 'status' },
      { value: { status: 'on moderation' }, content: 'ON MODERATION', group: 'status' },
      { value: { status: 'rejected' }, content: 'REJECTED', group: 'status' },
      { value: { status: 'other' }, content: 'OTHER', group: 'status' },
      { value: { status: 'archived' }, content: 'ARCHIVED', group: 'status' },
      { value: { status: 'unmanaged' }, content: 'UNMANAGED', group: 'status' },
      { value: { status: 'ispush' }, content: 'PUSH CAMPAIGNS', group: 'status' },
    ],
    trackerAccountsMap: {},
  };
}
